import { queryParams, type RouteQueryOptions, type RouteDefinition, type RouteFormDefinition } from './../../../../wayfinder'
/**
* @see \App\Domain\OrganizationAccess\Presentation\Http\Controllers\OrgInvitationAcceptanceController::store
* @see app/Domain/OrganizationAccess/Presentation/Http/Controllers/OrgInvitationAcceptanceController.php:37
* @route 'https://org.proexpert.app/org/invitations/accept'
*/
export const store = (options?: RouteQueryOptions): RouteDefinition<'post'> => ({
    url: store.url(options),
    method: 'post',
})

store.definition = {
    methods: ["post"],
    url: 'https://org.proexpert.app/org/invitations/accept',
} satisfies RouteDefinition<["post"]>

/**
* @see \App\Domain\OrganizationAccess\Presentation\Http\Controllers\OrgInvitationAcceptanceController::store
* @see app/Domain/OrganizationAccess/Presentation/Http/Controllers/OrgInvitationAcceptanceController.php:37
* @route 'https://org.proexpert.app/org/invitations/accept'
*/
store.url = (options?: RouteQueryOptions) => {
    return store.definition.url + queryParams(options)
}

/**
* @see \App\Domain\OrganizationAccess\Presentation\Http\Controllers\OrgInvitationAcceptanceController::store
* @see app/Domain/OrganizationAccess/Presentation/Http/Controllers/OrgInvitationAcceptanceController.php:37
* @route 'https://org.proexpert.app/org/invitations/accept'
*/
store.post = (options?: RouteQueryOptions): RouteDefinition<'post'> => ({
    url: store.url(options),
    method: 'post',
})

/**
* @see \App\Domain\OrganizationAccess\Presentation\Http\Controllers\OrgInvitationAcceptanceController::store
* @see app/Domain/OrganizationAccess/Presentation/Http/Controllers/OrgInvitationAcceptanceController.php:37
* @route 'https://org.proexpert.app/org/invitations/accept'
*/
const storeForm = (options?: RouteQueryOptions): RouteFormDefinition<'post'> => ({
    action: store.url(options),
    method: 'post',
})

/**
* @see \App\Domain\OrganizationAccess\Presentation\Http\Controllers\OrgInvitationAcceptanceController::store
* @see app/Domain/OrganizationAccess/Presentation/Http/Controllers/OrgInvitationAcceptanceController.php:37
* @route 'https://org.proexpert.app/org/invitations/accept'
*/
storeForm.post = (options?: RouteQueryOptions): RouteFormDefinition<'post'> => ({
    action: store.url(options),
    method: 'post',
})

store.form = storeForm

const accept = {
    store: Object.assign(store, store),
}

export default accept